import React from 'react';
import {Form} from 'semantic-ui-react';

const GroupForm = ({text1, label1, text2, label2, text3, label3}) => {
  return (
    <Form.Group widths="equal">
      <Form.Input value={text1} fluid label={label1} placeholder={label1} disabled/>
      <Form.Input value={text2} fluid label={label2} placeholder={label2} disabled/>
      <Form.Input value={text3} fluid label={label3} placeholder={label3} disabled/>
    </Form.Group>
  );
};
export default GroupForm;
